module.exports = __webpack_public_path__ + "img/room_icon.5cba8578.svg";